import React from 'react';
import Loadable from 'react-loadable';
import { connect } from 'react-redux';
import { isPrimeUser } from 'utils/common';
import { getSessionStorage, getLocalStorage } from 'utils/storageUtils';
import { ALREADY_PRIME_USER_STORAGE_NAME, PLAN_ACTION } from '../../constants';

const LoadableComponent = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'AlreadyPrimeToastLoader' */ './AlreadyPrimeToast'),
  loading: () => null,
  // timeout: 50000,
});

class AlreadyPrimeToastLoader extends React.Component {
  constructor() {
    super();
    this.state = {
      showPrimeToast: false,
      planAction: false,
    };
  }

  componentDidMount() {
    window.addEventListener('user.autologgedin', this.renderAlreadyPrimeToast);
  }

  closeAlreadyPrimeToast = () => {
    this.setState({ showPrimeToast: false });
    sessionStorage.removeItem(ALREADY_PRIME_USER_STORAGE_NAME);
  };

  showAlreadyPrimeToast = () => {
    this.setState({ showPrimeToast: true });
    // setTimeout(() => {
    //   this.closeAlreadyPrimeToast();
    // }, 10000);
  };

  renderAlreadyPrimeToast = () => {
    this.isPaidToipArticle =
      sessionStorage?.getItem('paidstories') &&
      sessionStorage
        ?.getItem('paidstories')
        ?.split(',')
        .indexOf(this.props.msid) > -1;

    const isPaidStoryArrAlreadyOpenedPopup =
      localStorage?.getItem('paidStoryArrAlreadyOpenedPopup') &&
      localStorage
        ?.getItem('paidStoryArrAlreadyOpenedPopup')
        ?.split(',')
        .indexOf(this.props.msid) > -1;

    const toastStorageExist = getSessionStorage(
      ALREADY_PRIME_USER_STORAGE_NAME,
    );
    const planAction = getLocalStorage(PLAN_ACTION);
    if (planAction === 'timesPrime') {
      this.setState({
        planAction: true,
      });
    }
    if (
      (parseInt(toastStorageExist, 10) === 1 && isPrimeUser()) ||
      (this.props.isPrime &&
        this.isPaidToipArticle &&
        !isPaidStoryArrAlreadyOpenedPopup)
    ) {
      this.showAlreadyPrimeToast();
    }
  };

  render() {
    //if (this.props.forceHide === true) return null;
    if (!this.state.showPrimeToast) return null;
    return (
      <LoadableComponent
        {...this.props}
        show={this.state.showPrimeToast}
        closeAlreadyPrimeToast={this.closeAlreadyPrimeToast}
        planAction={this.state.planAction}
        isPaidToipArticle={this.isPaidToipArticle}
        isPrimeUser={isPrimeUser()}
      />
    );
  }
}

export default connect()(AlreadyPrimeToastLoader);
